<template>
  <div class="col-lg-12 left-side-product-box pb-0">
    <img
      v-if="current_product.IconLocation"
      v-bind:src="ImageMainUrl"
      class="border p-0"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ProductImageThumbnail",
  props: {
    product_object: { type: Object }
  },
  data() {
    return {
      current_product: this.product_object
    };
  },
  methods: {},
  created() {},
  computed: {
    ...mapState(["product", "global"]),

    ImageMainUrl() {
      return (
        this.$store.state.global.apiResourceUrl +
        this.current_product.IconLocation
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.left-side-product-box .sub-img img {
  margin-top: 5px;
  /*width: 83px;
  height: 100px;*/
  width: 33%;
  padding-top: 10px;
}
.pro-box-section .pro-box img {
  width: 100%;
  height: 200px;
}

@media (min-width: 360px) and (max-width: 640px) {
  .pro-box-section .pro-box img {
    height: auto;
  }
}
.left-side-product-box img {
  width: 100%;
}
.fit-image {
  width: 100%;
  object-fit: cover;
  height: 300px; /* only if you want fixed height */
}
</style>
